<template>
    <bc-tooltip v-if="!!dialogStatus || dialogModel || action" class="ml-auto">
        <template slot="activator">
            <app-section-loader :status="modal_loader"></app-section-loader> <!-- modal_loader in store -->
            <v-btn icon @mouseup.left="$emit('invoke-method', dialogInfo)" tabindex="-1">
                <v-icon class="fs-32">close</v-icon>
            </v-btn>
        </template>
        {{ $t('lang.close') }}
    </bc-tooltip>
</template>

<script>

import { mapGetters } from "vuex";

export default {
    props: {
        dialogModel: { // name of variable that is the v-model of the modal that <bc-btn-dialog-close> is in
            type: String
        },
        action: { // name of function that will run when 'close' is triggered
            type: String,
        },
        dialogStatus: { // value of v-model of the modal that <bc-btn-dialog-close> is in
            type: Boolean
        },
        params: { // array of parameters for function named in 'action' prop
            type: Array
        },
    },
    computed: {
        dialogInfo() {
            if(this.action){ // if action is defined it is priority, assumes dialog is closed within action
                let action_obj = { action: this.action }
                if(this.params) action_obj.params = this.params
                return action_obj
            }else if(this.dialogModel){
                return {
                    action: 'control_dialog',
                    dialog_model: this.dialogModel,
                    status: false
                }
            }else{
                return null;
            }
        },
        ...mapGetters([
            "modal_loader"
        ])
    },
    mounted: function(){
        this.$root.$on('escapePressed', data => {
            if(typeof(this.dialogStatus) == 'undefined' || (typeof(this.dialogStatus) !== 'undefined' && this.dialogStatus)){
                this.$emit('invoke-method', this.dialogInfo); // only close dialog if the dialog is currently open //TODO: only close if upper-most dialog
                this.$store.commit('toggleModalLoader', false);
            }
            if(typeof(this.dialogStatus) == 'undefined'){
                throw new Error('Missing "dialog-status" prop (boolean) on <bc-btn-dialog-close> component' + (this.dialogModel !== undefined ? ' in modal with v-model: `' + this.dialogModel + '`' : (this.action ? ' with action: `' + this.action + '`' : '')));
            }
            // if(this.dialogModel == undefined && this.action == undefined){
            //     throw new Error('Missing required `dialog-model` or `action` prop on <bc-btn-dialog-close> component');
            // }
        });
    }
}
</script>